export default __webpack_public_path__ + "static/AppBeers5-d7876b271ba68b9e75aa7173e448a5a4.png";